import MappingPresetModal from './MappingPresetModal';
import DriverPayModal from './DriverPayModal';
import LocationInfoModal from './LocationInfoModal';
import QuoteMatchModal from './QuoteMatchModal';
import RescheduleModal from './RescheduleModal';
import StreetTurnModal from './StreetTurnModal';
import TracingModal from './TracingModal';
import HoldsModal from './HoldsModal';
import AddToBLModal from './AddToBLModal';
import QuantityDetailsModal from './QuantityDetailsModal/QuantityDetailsModal';
import OrderSupportRequestLatestCommentModal from '../pages/SupportRequestsPage/OrderSupportRequestLatestCommentModal';
import PresetValidationModal from './PresetValidationModal';
import OrderHazmatApprovalModal from './OrderHazmatApprovalModal/OrderHazmatApprovalModal';

export {
  MappingPresetModal,
  DriverPayModal,
  LocationInfoModal,
  QuoteMatchModal,
  RescheduleModal,
  StreetTurnModal,
  TracingModal,
  HoldsModal,
  AddToBLModal,
  PresetValidationModal,
  OrderHazmatApprovalModal
};

export const orderModals = {
  LOCATION_INFO_MODAL: LocationInfoModal,
  MAPPING_PRESET_MODAL: MappingPresetModal,
  HOLDS_MODAL: HoldsModal,
  ADD_TO_BL_MODAL: AddToBLModal,
  QUANITY_DETAILS_MODAL: QuantityDetailsModal,
  ORDER_SUPPORT_REQUEST_LATEST_COMMENT_MODAL: OrderSupportRequestLatestCommentModal,
  PRESET_VALIDATION_MODAL: PresetValidationModal,
  ORDER_HAZMAT_APPROVAL_MODAL: OrderHazmatApprovalModal,
};
